import { createRouter, createWebHistory } from "vue-router";
const routes = [
  {
    path: "/goodsInfo", //商品详情
    name: "goodsInfo",
    component: () =>
      import(/* webpackChunkName: "goodsInfo" */ "../views/goodsInfo.vue"),
  },
  {
    path: "/shopList", //店铺详情
    name: "shopList",
    component: () =>
      import(/* webpackChunkName: "shopList" */ "../views/shopList.vue"),
  },
  {
    path: "/nicheInfo", // 商机详情
    name: "nicheInfo",
    component: () =>
      import(/* webpackChunkName: "nicheInfo" */ "../views/nicheInfo.vue"),
  },
  {
    path: "/mainteNance", //维修保养详情
    name: "mainteNance",
    component: () =>
      import(/* webpackChunkName: "mainteNance" */ "../views/mainteNance.vue"),
  },
  {
    path: "/userAgreement", //用户注册协议
    name: "userAgreement",
    meta: { title: "用户注册协议" },
    component: () =>
      import(
        /* webpackChunkName: "userAgreement" */ "../views/userAgreement.vue"
      ),
  },
  {
    path: "/privacyAgreement", //用户隐私协议
    name: "privacyAgreement",
    meta: { title: "用户隐私协议" },
    component: () =>
      import(
        /* webpackChunkName: "privacyAgreement" */ "../views/privacyAgreement.vue"
      ),
  },
  {
    path: "/memberAgreement", //会员服务协议
    name: "memberAgreement",
    meta: { title: "会员服务协议" },
    component: () =>
      import(
        /* webpackChunkName: "memberAgreement" */ "../views/memberAgreement.vue"
      ),
  },
  {
    path: "/exhibitionAgreement", //展会协议
    name: "exhibitionAgreement",
    meta: { title: "展会协议" },
    component: () =>
      import(
        /* webpackChunkName: "exhibitionAgreement" */ "../views/exhibitionAgreement.vue"
      ),
  },
  {
    path: "/upExample", //上传示例
    name: "upExample",
    component: () =>
      import(/* webpackChunkName: "upExample" */ "../views/upExample.vue"),
  },
  {
    path: "/shopGoods", //店铺搜索页
    name: "shopGoods",
    component: () =>
      import(/* webpackChunkName: "shopGoods" */ "../views/shopGoods.vue"),
  },
  {
    path: "/systemNotice", //系统通知详情
    name: "systemNotice",
    component: () =>
      import(
        /* webpackChunkName: "systemNotice" */ "../views/systemNotice.vue"
      ),
  },
  {
    path: "/agreementList", //协议列表
    name: "agreementList",
    meta: { title: "查看协议" },
    component: () =>
      import(
        /* webpackChunkName: "agreementList" */ "../views/agreementList.vue"
      ),
  },
  {
    path: "/myInfo", //关于我们
    name: "myInfo",
    component: () =>
      import(/* webpackChunkName: "myInfo" */ "../views/myInfo.vue"),
  },
  {
    path: "/download", //APP下载页
    name: "download",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 10 },
    component: () =>
      import(/* webpackChunkName: "download" */ "../views/download.vue"),
  },
  {
    path: "/downloadWx", //下载页
    name: "downloadWx",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "downloadWx" */ "../views/downloadWx.vue"),
  },
  {
    path: "/join", //店铺邀请成员加入
    name: "join",
    component: () => import(/* webpackChunkName: "join" */ "../views/join.vue"),
  },
  {
    path: "/ShareRegistration", //运营邀请
    name: "ShareRegistration",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(
        /* webpackChunkName: "ShareRegistration" */ "../views/ShareRegistration.vue"
      ),
  },
  {
    path: "/registerInfo", //运营邀请
    name: "registerInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(
        /* webpackChunkName: "registerInfo" */ "../views/registerInfo.vue"
      ),
  },
  {
    path: "/siginUp", //近期活动
    name: "siginUp",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 1 },
    component: () =>
      import(/* webpackChunkName: "siginUp" */ "../views/siginUp.vue"),
  },
  {
    path: "/trade", //房贸报名
    name: "trade",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 2 },
    component: () =>
      import(/* webpackChunkName: "trade" */ "../views/trade.vue"),
  },
  {
    path: "/tradeRegistered", //房贸活动已报
    name: "tradeRegistered",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 3 },
    component: () =>
      import(
        /* webpackChunkName: "tradeRegistered" */ "../views/tradeRegistered.vue"
      ),
  },
  {
    path: "/tradeSignup", //报名
    name: "tradeSignup",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 4 },
    component: () =>
      import(/* webpackChunkName: "tradeSignup" */ "../views/tradeSignup.vue"),
  },
  {
    path: "/tradeSignupInfo", //报名成功
    name: "tradeSignupInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 5 },
    component: () =>
      import(
        /* webpackChunkName: "tradeSignupInfo" */ "../views/tradeSignupInfo.vue"
      ),
  },
  {
    path: "/retraining", //复训
    name: "retraining",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 6 },
    component: () =>
      import(/* webpackChunkName: "retraining" */ "../views/retraining.vue"),
  },
  {
    path: "/retrainingSignup", //复训报名
    name: "retrainingSignup",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 7 },
    component: () =>
      import(
        /* webpackChunkName: "retrainingSignup" */ "../views/retrainingSignup.vue"
      ),
  },
  {
    path: "/rgSignupInfo", //复训报名成功
    name: "rgSignupInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 8 },
    component: () =>
      import(
        /* webpackChunkName: "rgSignupInfo" */ "../views/rgSignupInfo.vue"
      ),
  },
  {
    path: "/retrainingSignupList", //复训报名人
    name: "retrainingSignupList",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 9 },
    component: () =>
      import(
        /* webpackChunkName: "trade" */ "../views/retrainingSignupList.vue"
      ),
  },
  {
    path: "/tradeEditInfo", // 房贸编辑订单
    name: "tradeEditInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 11 },
    component: () =>
      import(
        /* webpackChunkName: "tradeEditInfo" */ "../views/tradeEditInfo.vue"
      ),
  },
  {
    path: "/retrainEditInfo", // 复训编辑订单
    name: "retrainEditInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 12 },
    component: () =>
      import(
        /* webpackChunkName: "retrainEditInfo" */ "../views/retrainEditInfo.vue"
      ),
  },
  {
    path: "/adminLogin", // 登录页
    name: "login",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 13 },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/admin/login.vue"),
  },
  {
    path: "/userInfo", // 信息页
    name: "userInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 14 },
    component: () =>
      import(/* webpackChunkName: "userInfo" */ "../views/admin/userInfo.vue"),
  },
  {
    path: "/setInfo", // 设置信息页
    name: "setInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 15 },
    component: () =>
      import(/* webpackChunkName: "setInfo" */ "../views/admin/setInfo.vue"),
  },
  {
    path: "/adminShopList", // 店铺列表
    name: "adminShopList",
    meta: {
      title: "奢哈哈-更好用的二奢进销存平台",
      index: 16,
      keepAlive: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminShopList" */ "../views/admin/adminShopList.vue"
      ),
  },
  {
    path: "/adminStoreDetail", // 店铺详情
    name: "adminStoreDetail",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 17 },
    component: () =>
      import(
        /* webpackChunkName: "adminStoreDetail" */ "../views/admin/storeDetail.vue"
      ),
  },

  {
    path: "/adminStoreLogin", // 店铺后台登录
    name: "adminStoreLogin",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 18 },
    component: () =>
      import(
        /* webpackChunkName: "adminStoreLogin" */ "../views/shop/login.vue"
      ),
  },
  {
    path: "/adminStoreInfo", // 店铺后台信息
    name: "adminStoreInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 19 },
    component: () =>
      import(
        /* webpackChunkName: "adminStoreInfo" */ "../views/shop/userInfo.vue"
      ),
  },
  {
    path: "/adminStoreSet", // 店铺后台信息设置
    name: "adminStoreSet",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 20 },
    component: () =>
      import(
        /* webpackChunkName: "adminStoreSet" */ "../views/shop/setInfo.vue"
      ),
  },

  {
    path: "/commodWareh", // 商品仓库
    name: "commodWareh",
    meta: {
      title: "奢哈哈-更好用的二奢进销存平台",
      index: 22,
      keepAlive: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "commodWareh" */ "../views/shop/commodWareh.vue"
      ),
  },
  {
    path: "/batchPublishing", // 店铺后台批量导入
    name: "batchPublishing",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 22 },
    component: () =>
      import(
        /* webpackChunkName: "batchPublishing" */ "../views/shop/batchPublishing.vue"
      ),
  },
  {
    path: "/productDetail", // 店铺后台商品详情
    name: "productDetail",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 23 },
    component: () =>
      import(
        /* webpackChunkName: "productDetail" */ "../views/shop/productDetail.vue"
      ),
  },
  {
    path: "/goodsWarehousing", // 店铺后台商品编辑
    name: "goodsWarehousing",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 24 },
    component: () =>
      import(
        /* webpackChunkName: "goodsWarehousing" */ "../views/shop/productEdit.vue"
      ),
  },
  {
    path: "/exportTask", // 店铺后台商品导出队列
    name: "exportTask",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 25 },
    component: () =>
      import(
        /* webpackChunkName: "exportTask" */ "../views/shop/exportTask.vue"
      ),
  },
  {
    path: "/storeRedeem", // 店铺后台 赎回
    name: "storeRedeem",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 26 },
    component: () =>
      import(/* webpackChunkName: "storeRedeem" */ "../views/shop/redeem.vue"),
  },
  {
    path: "/storeBill", // 店铺后台 开单
    name: "storeBill",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 27 },
    component: () =>
      import(/* webpackChunkName: "storeBill" */ "../views/shop/storeBill.vue"),
  },
  {
    path: "/95Introduction", // 95分 介绍
    name: "95Introduction",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "95Introduction" */ "../views/95-points-introduction.vue"),
  },
  {
    path: "/95Instructions", // 95分 使用说明
    name: "95Instructions",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "95Instructions" */ "../views/instructions.vue"),
  },
  {
    path: "/alipayInfo", //  支付宝小程序上传资料
    name: "alipayInfo",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "alipayInfo" */ "../views/alipayInfo.vue"),
  },
  {
    path: "/unsecuredLease", //  租赁免押
    name: "unsecuredLease",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "unsecuredLease" */ "../views/unsecuredLease.vue"),
  },
  {
    path: "/unsecuredAgreement", //  租赁免押协议
    name: "unsecuredAgreement",
    meta: { title: "商品租赁服务协议" },
    component: () =>
      import(/* webpackChunkName: "unsecuredAgreement" */ "../views/unsecuredAgreement.vue"),
  },
  {
    path: "/merchantAgreement", //  商家协议
    name: "merchantAgreement",
    meta: { title: "商家入驻协议" },
    component: () =>
      import(/* webpackChunkName: "merchantAgreement" */ "../views/merchantAgreement.vue"),
  },
  {
    path: "/forSaleAgreement", //  奢哈哈挂售服务
    name: "forSaleAgreement",
    meta: { title: "挂售服务协议" },
    component: () =>
      import(/* webpackChunkName: "forSaleAgreement" */ "../views/forSaleAgreement.vue"),
  },
  {
    path: "/buyerAgreement", //  买家须知
    name: "buyerAgreement",
    meta: { title: "买家须知" },
    component: () =>
      import(/* webpackChunkName: "buyerAgreement" */ "../views/buyerAgreement.vue"),
  },
  {
    path: "/backAgreement", //  72小时无理由退款
    name: "backAgreement",
    meta: { title: "72小时无理由退款" },
    component: () =>
      import(/* webpackChunkName: "backAgreement" */ "../views/backAgreement.vue"),
  },
  {
    path: "/alipayInstructions", // 支付宝小程序使用说明
    name: "alipayInstructions",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "alipayInstructions" */ "../views/alipayInstructions.vue"),
  },

  {
    path: "/feedback", // 建议
    name: "feedback",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "feedback" */ "../views/feedback.vue"),
  },
  {
    path: "/operatingManual", // 操作手册
    name: "operatingManual",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "operatingManual" */ "../views/operatingManual.vue"),
  },
  {
    path: "/operatingManual2", // 操作手册
    name: "operatingManual2",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "operatingManual2" */ "../views/operatingManual2.vue"),
  },
  {
    path: "/adminUserList", // 用户列表
    name: "adminUserList",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "adminUserList" */ "../views/admin/adminUserList.vue"),
  },
  {
    path: "/adminUserDetail", // 用户列表详情
    name: "adminUserDetail",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "userDetail" */ "../views/admin/userDetail.vue"),
  },
  {
    path: "/upstreamDetection", // 中溯鉴定
    name: "upstreamDetection",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 30 },
    component: () =>
      import(/* webpackChunkName: "upstreamDetection" */ "../views/upstreamDetection.vue"),
  },
  {
    path: "/microPurchaseAlbum", // 微购相册
    name: "microPurchaseAlbum",
    meta: { title: "奢哈哈-更好用的二奢进销存平台" },
    component: () =>
      import(/* webpackChunkName: "microPurchaseAlbum" */ "../views/microPurchaseAlbum.vue"),
  },
  {
    path: "/identifyProduct", // 中溯鉴定
    name: "identifyProduct",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 29 },
    component: () =>
      import(/* webpackChunkName: "identifyProduct" */ "../views/identifyProduct/identifyProduct.vue"),
  },
  {
    path: "/identifyOrder", // 中溯鉴定订单列表
    name: "identifyOrder",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 31 },
    component: () =>
      import(/* webpackChunkName: "identifyOrder" */ "../views/identifyProduct/identifyOrder.vue"),
  },
  {
    path: "/createIdentify", // 添加送检
    name: "createIdentify",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 32 },
    component: () =>
      import(/* webpackChunkName: "createIdentify" */ "../views/identifyProduct/createIdentify.vue"),
  },
  {
    path: "/manyProduct", // 添加送检多件商品
    name: "manyProduct",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 33 },
    component: () =>
      import(/* webpackChunkName: "manyProduct" */ "../views/identifyProduct/manyProduct.vue"),
  },
  {
    path: "/identifyPay", // 送检支付
    name: "identifyPay",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 34 },
    component: () =>
      import(/* webpackChunkName: "identifyPay" */ "../views/identifyProduct/identifyPay.vue"),
  },
  {
    path: "/identifyDetail", // 送检详情
    name: "identifyDetail",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 35 },
    component: () =>
      import(/* webpackChunkName: "identifyDetail" */ "../views/identifyProduct/identifyDetail.vue"),
  },
  {
    path: "/priceShare", // 公价分享详情
    name: "priceShare",
    meta: { title: "奢哈哈-更好用的二奢进销存平台", index: 36 },
    component: () =>
      import(/* webpackChunkName: "priceShare" */ "../views/priceShare.vue"),
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
// 总后台
export const routeUnWhiteList = [
  "/userInfo",
  "/setInfo",
  "/adminShopList",
  "/adminStoreDetail",
  "/adminUserList",
  "/adminUserDetail"
]; //  总后台登录需要验证是否已经登录过了

export const storeRouteUnWhiteList = [
  "/adminStoreInfo",
  "/adminStoreSetInfo",
  "/batchPublishing",
  "/productDetail",
  "/adminStoreSet",
  "/goodsWarehousing",
  "/exportTask",
  "/storeRedeem",
  "/storeBill",
  "/commodWareh",
]; //  店铺后台登录需要验证是否已经登录过了

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 总后台
  if (to.path == "/adminLogin") {
    if (localStorage.getItem("adminToken")) {
      return next("/userInfo");
    } else {
      return next();
    }
  }
  if (routeUnWhiteList.includes(to.path)) {
    if (localStorage.getItem("adminToken")) {
      return next();
    } else {
      return next("/adminLogin");
    }
  }
  // 店铺后台
  if (to.path == "/adminStoreLogin") {
    if (localStorage.getItem("adminStoreToken")) {
      return next("/adminStoreInfo");
    } else {
      return next();
    }
  }
  if (storeRouteUnWhiteList.includes(to.path)) {
    if (localStorage.getItem("adminStoreToken")) {
      return next();
    } else {
      return next("/adminStoreLogin");
    }
  }
  next();
});

export default router;
